<div class="tooth" [ngClass]="toothStatus()" (click)="onToothClick()"></div>
